import React from 'react'
import styles from './mask-content.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const MaskContent = ({ classes, children, className, apply }) => (
  <div
    className={classNames(classes.container, className, {
      [classes.apply]: apply
    })}>
    {children}
  </div>
)

export default injectSheet(styles)(MaskContent)
